import { useDiagramTheme } from './useDiagramTheme';

export function SessionStateDiagram() {
  const p = useDiagramTheme();

  const stateNodes = [
    { label: 'DRAFT',        sub: 'Being configured',    bg: p.grayBg,    border: p.grayBorder,    text: p.grayText },
    { label: 'OPEN',         sub: 'Participants working', bg: p.indigoBg,  border: p.indigoBorder,  text: p.indigoText },
    { label: 'RUN COMPLETE', sub: 'Scoring done',         bg: p.amberBg,   border: p.amberBorder,   text: p.amberText },
    { label: 'RESULTS READY',sub: 'Reviewed',             bg: p.emeraldBg, border: p.emeraldBorder, text: p.emeraldText },
    { label: 'PUBLISHED',    sub: 'Final output',         bg: p.greenBg,   border: p.greenBorder,   text: p.greenText },
  ];

  return (
    <div className="w-full space-y-4">
      {/* State machine */}
      <div
        className="border p-4 overflow-x-auto transition-colors"
        style={{ background: p.canvasBg, borderColor: p.canvasBorder }}
      >
        <p className="text-xs font-semibold uppercase tracking-wide mb-3" style={{ color: p.nodeSubText }}>Session States</p>
        <svg viewBox="0 0 680 100" className="w-full" style={{ minWidth: 500 }}>
          <defs>
            <marker id="ss-arrow" markerWidth="7" markerHeight="7" refX="6" refY="3" orient="auto">
              <path d="M0,0 L0,6 L7,3 z" fill={p.arrowColor} />
            </marker>
          </defs>

          {stateNodes.map((s, i) => {
            const x = 10 + i * 135;
            return (
              <g key={s.label}>
                <rect x={x} y="20" width="120" height="50" rx="7" fill={s.bg} stroke={s.border} strokeWidth="1.5" />
                <text x={x + 60} y="42" textAnchor="middle" fontSize="9" fontWeight="700" fill={s.text} fontFamily="sans-serif">{s.label}</text>
                <text x={x + 60} y="57" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">{s.sub}</text>
                {i < stateNodes.length - 1 && (
                  <line x1={x + 122} y1="45" x2={x + 133} y2="45" stroke={p.arrowColor} strokeWidth="1.5" markerEnd="url(#ss-arrow)" />
                )}
              </g>
            );
          })}
        </svg>
      </div>

      {/* Session types grid */}
      <div
        className="border p-4 transition-colors"
        style={{ background: p.canvasBg, borderColor: p.canvasBorder }}
      >
        <p className="text-xs font-semibold uppercase tracking-wide mb-3" style={{ color: p.nodeSubText }}>Session Types</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
          {[
            { type: 'participants', label: 'Participants', desc: 'Who is included in this session', category: 'Config' },
            { type: 'item_pool',   label: 'Item Pool',    desc: 'Which items belong in the comparison set', category: 'Config' },
            { type: 'criteria',    label: 'Criteria',     desc: 'Which scoring dimensions matter', category: 'Config' },
            { type: 'scales',      label: 'Scales',       desc: 'Ranges and bands for each criterion', category: 'Config' },
            { type: 'values',      label: 'Values',       desc: 'Converge what is true about items', category: 'Config' },
            { type: 'items',       label: 'Items (Ranking)', desc: 'Force-rank items against each other', category: 'Ranking' },
          ].map((t) => (
            <div
              key={t.type}
              className="border p-2.5 transition-colors"
              style={{
                background: t.category === 'Ranking' ? p.emeraldBg : p.violetBg,
                borderColor: t.category === 'Ranking' ? p.emeraldBorder : p.violetBorder,
              }}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-bold font-mono" style={{ color: t.category === 'Ranking' ? p.emeraldText : p.violetText }}>{t.type}</span>
                <span
                  className="text-xs px-1.5 py-0.5 rounded-full font-medium"
                  style={{
                    background: t.category === 'Ranking' ? p.emeraldBg : p.violetBg,
                    color: t.category === 'Ranking' ? p.emeraldText : p.violetText,
                    border: `1px solid ${t.category === 'Ranking' ? p.emeraldBorder : p.violetBorder}`,
                  }}
                >
                  {t.category}
                </span>
              </div>
              <p className="text-xs leading-relaxed" style={{ color: p.nodeSubText }}>{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
